import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { claimsFieldWidth } from "../Helpers/claimsFieldWidth";
import { FreightClaimType } from "@freightsimple/generated-dashboard-openapi-client/models/FreightClaimType";

interface ClaimTypeDropdownProps {
  claimType: FreightClaimType;
  setClaimType: (_: FreightClaimType) => void;
}

export function ClaimsTypeDropdown(props: ClaimTypeDropdownProps) {
  const { claimType, setClaimType } = props;
  return (
    <Dropdown
      data-testid="freight-claim-type-dropdown"
      value={claimType}
      onChange={(v) => setClaimType(v as FreightClaimType)}
      width={claimsFieldWidth.token}
      options={[
        {
          value: FreightClaimType.NoDamageOrLoss,
          label: "👍 No Damage or Loss",
        },
        {
          value: FreightClaimType.Damage,
          label: "❌ Damage",
        },
        {
          value: FreightClaimType.Loss,
          label: "❌ Loss",
        },
      ]}
    />
  );
}
